import { gql } from "@apollo/client";
import { ResourceHubBaseFragment } from "./resource-hub";

export const QUERY_FETCH_USER_DOWNLOADED_RESOURCES = gql`
  query fetchUserDownloadedResources($limit: Int) {
    fetchUserDownloadedResources(limit: $limit) {
      ...ResourceHubBaseFragment
    }
  }
  ${ResourceHubBaseFragment}
`;
